import type { UseQueryResult } from '@tanstack/react-query';

import type { FamilyWithClusters, JobFamily } from '~/shared/data-contract/job-family';

import { useFamiliesWithClustersQuery } from './use-families-with-clusters';

const stripClusters = (families: readonly FamilyWithClusters[]): readonly JobFamily[] =>
    families.map(({ clusters: _clusters, ...family }) => family);

export const useJobFamilies = (
    jobArchitectureId: string,
    options?: { readonly enabled?: boolean },
): UseQueryResult<readonly JobFamily[], Error> =>
    useFamiliesWithClustersQuery(jobArchitectureId, {
        enabled: options?.enabled,
        select: stripClusters,
    });

export const useIsJobFamilyGenerating = (jobArchitectureId: string, jobFamilyId: string): boolean => {
    const { data: jobFamilies } = useJobFamilies(jobArchitectureId);

    return (
        jobFamilies?.some(
            (jobFamily) => jobFamily.id === jobFamilyId && jobFamily.generationInfo?.inProgress === true,
        ) ?? false
    );
};
